<div class="backdrop">
  <span class="load-label">{{ titulo }}</span>

  <div class="spinner-border text-light" role="status">
    <span class="sr-only"></span>
  </div>
</div>
